import {CheyCheyImageProps, stateStatusType, } from './actionType';

// FetchVideoGroupSState
export interface FetchCheyCheyState {
    isLoading: boolean;
    error: string | null;
    cheyCheyImage: CheyCheyImageProps[];
    status: stateStatusType | null;
    delete: string | null;
}

export const initialVideoGroupsState: FetchCheyCheyState = {
    isLoading: false,
    error: null,
    cheyCheyImage:[],
    status: null,
    delete:null
};

export interface CheyCheyImageState {
    cheyCheyImageState: FetchCheyCheyState;
}

export const initialState: CheyCheyImageState = {
    cheyCheyImageState: initialVideoGroupsState,
};


